import { get } from 'lodash';

export const weightMessages = {
    true: {
        strong: 'Validación de peso rechazada. ',
        regular: 'Verifica junto al shopper que el total de unidades por producto en el carro está correcto antes de aprobar la auditoría.',
        switchable: true
    },
    false: {
        strong: 'Validación de peso aprobada.',
        regular: '',
        switchable: false
    }
};

const getColorAndTextSemaphore = (type) => {
    if (type === 'small') return { color: '#1fa02e', text: 'Baja', backgroundColor: '#E6F5F1' };
    if (type === 'medium') return { color: '#EB963C', text: 'Media', backgroundColor: 'rgb(255, 242, 208)' };
    if (type === 'large') return { color: '#cc2c3b', text: 'Alta', backgroundColor: '#f9e6e8' };
};


export const getWeightValidationVisuals = (weightError, semaphore) => {
    const error = {
        msg: get(weightMessages, `${weightError}.strong`),
        tail: get(weightMessages, `${weightError}.regular`),
        color: '#BD2C00',
        icon: 'alert-circle',
        bgColor: '#F7E6E1',
        borderColor: '#BD2C00'
    };

    const success = {
        msg: get(weightMessages, `${weightError}.strong`),
        tail: get(weightMessages, `${weightError}.regular`),
        color: '#22A889',
        icon: 'checkmark-circle',
        bgColor: '#E6F5F1',
        borderColor: '#B6DFD6'
    };

    const visuals = weightError === 'true' ? error : success;
    const semaphoreStyles = getColorAndTextSemaphore(semaphore);

    return { ...visuals, semaphoreStyles };
};
